export default {
  computed: {},
  methods: {
    getWebsiteUrl(website) {
      let websiteUrl;
      if (website.includes('http://') || website.includes('https://')) {
        websiteUrl = website;
      } else {
        websiteUrl = `http://${website}`;
      }
      return websiteUrl;
    },
    getWebsiteText(website) {
      const websiteText = website.replace('http://', '').replace('https://', '').replace('www.', '');
      return websiteText;
    },
  },
};
